module.exports = __webpack_public_path__ + "static/media/25-14.4ba92124.mp3";